module.exports = __webpack_public_path__ + "static/media/header.eceb6884.png";